import { render, staticRenderFns } from "./AddTemplateDrawer.vue?vue&type=template&id=d6a55dde&"
import script from "./AddTemplateDrawer.vue?vue&type=script&lang=ts&"
export * from "./AddTemplateDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports